module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_c('strong', [_vm._v("Cooking with Joy")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "border"
  }, [_vm._v("THE 90/10 COOKBOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("Joy Bauer, M.S., R.D., C.D.N.,")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("with Rosemary Black     "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("       St. Martin’s Press  "), _c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781429983969_L01.png"
    }
  }), _vm._v("  New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45efc8a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429983969_epub_tp_r1.vue
// module id = 63
// module chunks = 0